import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Amplify } from 'aws-amplify';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

// Configure Amplify with deployed infrastructure values
Amplify.configure({
  Auth: {
    region: import.meta.env.VITE_REGION || 'us-east-1',
    userPoolId: import.meta.env.VITE_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    oauth: {
      domain: 'auth.interviewzen.com',
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: import.meta.env.VITE_ENVIRONMENT === 'production' 
        ? 'https://app.interviewzen.com/auth/callback'
        : 'http://localhost:3001/auth/callback',
      redirectSignOut: import.meta.env.VITE_ENVIRONMENT === 'production'
        ? 'https://app.interviewzen.com'
        : 'http://localhost:3001',
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'interviewzen',
        endpoint: import.meta.env.VITE_API_URL,
      },
    ],
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// Production build ready
